import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { obtenerDetalleDescargaPorGrado } from '../../actions/listados'
import DetalleDescargaPorGradoView from '../../components/listados/DetalleDescargaPorGradoView'

function DetalleDescargaPorGrado (props) {
  const { detalle, obtenerDetalleDescargaPorGrado, fechaDesde, fechaHasta } = props

  useEffect(() => {
    obtenerDetalleDescargaPorGrado(fechaDesde, fechaHasta, detalle.exportador, detalle.cereal, detalle.cerealVariedad)
  }, [obtenerDetalleDescargaPorGrado, detalle, fechaDesde, fechaHasta])

  return (
    <DetalleDescargaPorGradoView />
  )
}

const mapActionsToProps = {
  obtenerDetalleDescargaPorGrado
}

const mapStateToProps = (state) => ({
  fechaDesde: state.stock.fechaDPorGrado,
  fechaHasta: state.stock.fechaHPorGrado
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleDescargaPorGrado)
